import store from '../store/index'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ "../views/Home.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ "../views/Login.vue"),
    },
    {
        path: '/request',
        name: 'Request',
        component: () =>
            import(/* webpackChunkName: "Request" */ "../views/Request.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () =>
            import(/* webpackChunkName: "Logout" */ "../views/Logout.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/usuario',
        name: 'Editar Usuario',
        component: () =>
            import(/* webpackChunkName: "Moradores" */ "../views/editUsuario.vue"),
        meta: { requiresAuth: true }
    },
    {
        // pública: os operadores baixam a extensão do Situator sem ter login na central
        path: '/extensao',
        name: 'Extensao',
        component: () => import(/* webpackChunkName: "Extensao" */ "../views/ExtensaoDownload.vue"),
        meta: { requiresAuth: false }
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () =>
            import(/* webpackChunkName: "NotFound" */ "../views/NotFound.vue"),
        meta: { requiresAuth: false }
    },
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    let logged = store.getters.getLogged
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (logged) {
            store.dispatch('setShowMenu', true);
            next()
        } else {
            next({ path: '/login' })
        }
    } else {
        next()
    }

})

export default router